import { render } from "./CloseTask.vue?vue&type=template&id=81476548"
import script from "./CloseTask.vue?vue&type=script&lang=js"
export * from "./CloseTask.vue?vue&type=script&lang=js"

import "./CloseTask.vue?vue&type=style&index=0&id=81476548&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__